<template>
  <router-view />
</template>


<script type="text/javascript">
  import "@/assets/common.less"
  export default {
    name: "app",
    data() {
      return {
        path: '',
      }
    },
    components: {},
    mounted() {
      this.path = this.$route.path
    },
    watch: {
      $route(to, from) {
        this.path = to.path
      }
    },
  }
</script>